import { IOpenUserManagementService } from '@app/shared/auth/user-management/open-user-management-service';

export class OpenUserManagementService implements IOpenUserManagementService {
  constructor(private userManagementUrl: string) {}
  openUserManagement(): void {
    window.open(this.userManagementUrl, '_blank');
  }
}
